import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { UsersService } from '../../services/users.service';
import { RegisterService } from '../../services/register.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagePopupComponent } from '../../modals/message-popup/message-popup.component';

@Component({
  selector: 'app-change-password',
  standalone: false,
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  role: string;
  token: string;

  inputType1 = 'password';
  showHide1 = '../../../../assets/hide.svg';
  inputType2 = 'password';
  showHide2 = '../../../../assets/hide.svg';

  isError = false;
  isErrorText = 'form-is-not-valid';
  isLoading = false;

  constructor(
    private router: Router,
    private location: Location,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private modalService: BsModalService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    const user = this.authenticationService.userValue;
    if (user) {
      this.router.navigate(['/dashboard']);
    }
    this.isError = false;
    this.isErrorText = 'form-is-not-valid';

    // get role from path
    this.role = this.route.snapshot.params['role'];
    // get token from path
    this.token = this.route.snapshot.params['token'];

    this.initForms();
  }

  initForms() {
    this.form = this.fb.group({
      new_password: ['', [Validators.required, Validators.minLength(8)]],
      confirm_new_password: ['', Validators.required],
    });
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  showHideField(numri: any) {
    if (numri === 1) {
      if (this.inputType1 === 'password') {
        this.inputType1 = 'text';
        this.showHide1 = '../../../../assets/show.svg';
      } else {
        this.inputType1 = 'password';
        this.showHide1 = '../../../../assets/hide.svg';
      }
    }
    if (numri === 2) {
      if (this.inputType2 === 'password') {
        this.inputType2 = 'text';
        this.showHide2 = '../../../../assets/show.svg';
      } else {
        this.inputType2 = 'password';
        this.showHide2 = '../../../../assets/hide.svg';
      }
    }
  }

  async changePassword() {
    this.isError = false;
    this.isErrorText = 'something-went-wrong';

    if (this.form.get('new_password').invalid) {
      this.isError = true;
      this.isErrorText = 'password-is-not-valid';
      return;
    }

    if (
      this.form.get('new_password').value !==
      this.form.get('confirm_new_password').value
    ) {
      this.isError = true;
      this.isErrorText = 'passwords-are-not-equal';
      return;
    }

    this.isLoading = true;
    this.usersService
      .changePassword(this.role, this.token, this.form.value)
      .subscribe(
        async (response) => {
          console.log('response:');
          console.log(response);
          this.form.reset();
          this.inputType1 = 'password';
          this.showHide1 = '../../../../assets/hide.svg';
          this.inputType2 = 'password';
          this.showHide2 = '../../../../assets/hide.svg';

          this.isError = false;
          this.isLoading = false;
          this.isErrorText = 'something-went-wrong';
          let modal = this.modalService.show(MessagePopupComponent, {
            initialState: {
              title: 'password-changed',
              text: 'password-changed-text',
              buttonText: 'okay',
            },
            class: 'alert-modal modal-dialog-centered',
            backdrop: 'static',
          });
          modal.onHidden.subscribe(() => {
            if (this.role == 'business') {
              this.goToLogin();
            } else {
              this.isError = true;
              this.isErrorText = 'return-back-to-mobile-app';
            }
          });
        },
        (error) => {
          console.log('error:');
          console.log(error);
          this.isError = true;
          this.isLoading = false;
          this.isErrorText = 'something-went-wrong';
        },
      );
  }
}
